// 生命体验馆预约参观信息表头

export let lifeExperiencePavilionReservationTableLabels = [
  {
    label: '预约场次',
    value: 'date_time'
  },
  {
    label: '联系人手机号',
    value: 'mobile'
  },
  {
    label: '预约人数',
    value: 'personCount'
  },
  {
    label: '姓名',
    value: 'visitors[0].name'
  },
  {
    label: '证件类型',
    value: 'visitors.identityCardType'
  },
  {
    label: '证件号码',
    value: 'visitors.identityCard'
  },
  {
    label: '手机号',
    value: 'visitors.mobile'
  },
  {
    label: '发起时间',
    value: 'createdDate'
  }
]

export let filterLabels = [
  {
    label: '预约日期',
    type: 'time-slot',
    value: 'reservationDate',
    clearable: true,
    startName: 'reservationStartTime', // 返回数据时，开始时间的字段名
    endName: 'reservationEndTime' // 返回数据时，结束时间的字段名
  },
  {
    label: '场次',
    type: 'select',
    value: 'time',
    clearable: true,
    options: [
      { label: '上午场10:00-11:00', value: '上午 10:00-11:00' },
      { label: '下午场14:00-15:00', value: '下午 14:00-15:00' }
    ]
  },
  {
    label: '发起时间',
    type: 'time-slot',
    value: 'createdDate',
    clearable: true,
    startName: 'createdStartTime', // 返回数据时，开始时间的字段名
    endName: 'createdEndTime' // 返回数据时，结束时间的字段名
  }
]
export let statusTabs = [
  { label: '全部订单', value: 'ALL' },
  { label: '待审核', value: 'WAITING_AUDIT' },
  { label: '已取消', value: 'CANCEL' },
  { label: '已通过', value: 'APPROVED' }
]
export let receiveTypeOptions = {
  'EXPERIENCE_HALL': '科技馆',
  'BUSINESS': '业务部'
}
